const IS_DEV =
    (window?.process?.env?.NODE_ENV ?? process.env.NODE_ENV) ===
        'development' ||
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) === 'local';

// Cache buster for translation JSON files to avoid stale CDN content
const rawBuildTag =
    window?.process?.env?.BUILD_TAG ?? process.env.BUILD_TAG ?? '';
const translationCacheBuster =
    rawBuildTag && /^[\w.-]+$/.test(rawBuildTag)
        ? rawBuildTag
        : String(Date.now());

const cacheBustingBackendOptions = Array(2)
    .fill(null)
    .map(() => ({
        queryStringParams: {
            v: translationCacheBuster,
        },
    }));

// i18n common config
export default {
    debug: IS_DEV,
    defaultNS: 'app',
    fallbackNS: 'common',
    ns: ['app', 'common'],
    backend: {
        // Apply a per-build cache buster to translation JSON requests to avoid stale CDN content.
        // Provide entries for the first two backends (dev uses one, prod uses two); unused entries are ignored.
        backendOptions: cacheBustingBackendOptions,
    },
};
